import { useEffect, useState, type RefObject } from 'react'

/** Include uncommitted measurement text when deciding whether a form can be discarded. */
export function useMeasurementDrafts(ref: RefObject<HTMLElement>) {
  const [dirty, setDirty] = useState(false)
  useEffect(() => {
    const root = ref.current
    if (!root) return
    const update = () => setDirty(!!root.querySelector('[data-measurement-dirty="true"]'))
    const observer = new MutationObserver(update)
    observer.observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['data-measurement-dirty'] })
    update()
    return () => observer.disconnect()
  }, [ref])
  return dirty
}
